import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MapComponent } from './components/map/map.component';
import { LandingComponent } from './components/landing/landing.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { LoginComponent } from './components/login/login.component';


const appRoutes: Routes = [
  { path: 'landing', component: LandingComponent },
  { path: '', component: MapComponent },
  { path: 'login', component: LoginComponent },
  { path: 'cdmx', component: MapComponent },
  { path: 'yuc', component: MapComponent },
  { path: 'public', component: MapComponent },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: false } // <-- debugging purposes only
    )
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
